import React, { useEffect, useState } from 'react'
import { getTokens } from '../services/Auth';
import { baseURL, clients } from '../utils/Constants';
import { useNavigate } from 'react-router-dom';
import { ILoader } from '../App';
import MyDropdown from '../components/Dropdown/MyDropdown';

interface Props {
    handleLoader: ILoader,
}

export default function AuthPage({ handleLoader }: Props) {

    const navigate = useNavigate();
    const tempChannel = sessionStorage.getItem("temp_channel");  

    const [allowed, setAllowed] = useState<boolean>(true);
    const [channel, setChannel] = useState(tempChannel !== null ? tempChannel : Object.keys(clients)[0]);

    useEffect(() => {
        const channel: string = sessionStorage.getItem('temp_channel');
        if (channel === null) {
            return;
        }
        const accessCodePath = window.location.href.split('?code=');
        if (accessCodePath.length === 1) {
            const text: string = `Vuoi autenticarti per il canale ${channel}? \nPrima di procedere, assicurati di aver effettuato il LOGOUT su https://goto.com/it`;
            if (!window.confirm(text)) {
                setAllowed(false);
                return;
            } 
            setAllowed(true);
            window.location.replace(`https://authentication.logmeininc.com/oauth/authorize?client_id=${clients[channel].id}&response_type=code&redirect_uri=${baseURL}admin/authcode`)
            return;
        }

        auth(accessCodePath.pop());    
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const auth = async (code: string) => {
        handleLoader.setLoading(true);
        await getTokens('authorization_code', code, sessionStorage.getItem('temp_channel'));
        handleLoader.setLoading(false);
        const pathname: string = sessionStorage.getItem('last_path'); 
        sessionStorage.clear();
        navigate(pathname); 
    }

    const onChangeChannel = (newChannel: string) => {
        setChannel(newChannel);
        sessionStorage.setItem('temp_channel', newChannel);
        window.location.reload();
    }

    if (sessionStorage.getItem('temp_channel') === null) {
        return <div>
            Accesso non autorizzato!
        </div>
    }

    if (!allowed) {
        return <div>
            Accesso a Webinar annullato. <br />

            {/* <div className="mt-4">
                <h5>Scegli un canale Webinar a cui accedere</h5>
                <MyDropdown data={Object.keys(clients)} onChange={(v: string) => onChangeChannel(v)} value={channel}/>
            </div> */}
        </div>
    }

    return (
        <div>Autorizzazione in corso...</div>
    )
}
